const color = {
  white: '#ffffff',
  primary: '#E7472C',
  textGray: '#666666',
};

export default color;
